module.exports = __webpack_public_path__ + "img/privacy-2.ef066e9f.png";